define('plugin/product/controller/ProductController',['require','lib/controller/BaseController','plugin/product/view/ProductIndexView','controller/sub/ClientSubController','Config'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var ProductIndexView = require('plugin/product/view/ProductIndexView');

    var ClientSubController = require('controller/sub/ClientSubController');

    var Config = require('Config');

    /**
     * Product Controller
     *
     * @class ProductController
     */
    return BaseController.extend({

        _collection: null,
        _categoryCollection: null,
        _cartModel: null,
        _view: null,
        _message: null,
        _sort: 'name',

        initialize: function () {
            this._collection = this.getOption('collection');
            this._categoryCollection = this.getOption('categoryCollection');
            this._cartModel = this.getOption('cartModel');

            this.listenTo(this._cartModel, 'checkout', this.buyWithClientInfo.bind(this));

            BaseController.prototype.initialize.call(this);
        },

        /**
         * index action, displays list of products
         *
         * @param services
         */
        index: function (category, sort, page) {
            sort = sort || 'natural';
            var step = (category || !Config.getInstance().getOption('product_use_categories')) ? 'products' : 'categories';

            if (category != this._currentCategory || sort != this._sort || page != this._page) {
                this._currentCategory = category;
                this._sort = sort;
                this._page = page;
                this._step = step;
            
                this._collection.resetLoaded();
                this._collection.reset();
            }


            var _this = this;
            this.loadCollections().then(function() {
                _this._view = new ProductIndexView({
                    collection: _this._collection,
                    categoryCollection: _this._categoryCollection,
                    step: step,
                    url: 'products' + (category ? '/category/'+category : '') + (sort && sort != 'natural'? '/sort/'+sort : '') + '/page/:page',
                    category: category,
                    sort: step == 'products' ? sort : null,
                    cart: _this._cartModel
                });
    
                _this.listenTo(_this._view, 'buy', _this.onBuyProduct);
                _this.listenTo(_this._view, 'sort', _this.onSortChange);
    
                _this.getMainLayout().getContentRegion().show(_this._view);
    
                if (_this._message) {
                    _this._view.showErrorMessage(_this._message);
                    _this._message = null;
                }
            });
        },

        loadCollections: function() {
            var category = this._currentCategory, 
                page = this._page;
            var orderField, orderDirection;
            switch (this._sort) {
                case 'natural':
                    orderField = '';
                    orderDirection = '';
                    break;
                case 'name':
                    orderField = 'name';
                    orderDirection = 'ASC';
                    break;
                case 'price-asc':
                    orderField = 'price';
                    orderDirection = 'ASC';
                    break;
                case 'price-desc':
                    orderField = 'price';
                    orderDirection = 'DESC';
                    break;
            }

            var loadingPromises = [];
            if (this._step == 'products') {
                loadingPromises.push(this._collection.loadWithPromise({
                    data: {
                        'type': 'product',
                        'category': category,
                        'page': page,
                        'on_page': 10,
                        'order_field': orderField,
                        'order_direction': orderDirection
                    }
                }));
            }
                
            if (this._categoryCollection) {
                var _this = this;

                loadingPromises.push(this._categoryCollection.loadWithPromise({
                    data: {
                        'type': 'product'
                    }
                }).then(function() {
                    _this.checkCategories()
                }));
            }

            return Promise.all(loadingPromises);
        },

        onSortChange: function (sort) {
            this._redirect('products' + (this._currentCategory ? '/category/'+this._currentCategory : '') + (sort == 'natural' ? '' : '/sort/'+sort));
        },

        onBuyProduct: function (id, qty) {
            var product = this._collection.get(id);

            qty = ~~qty;
            if (qty < 1) {
                qty = 1;
            }

            this._cartModel.addItem(product, qty);
        },

        buyWithClientInfo: function () {
            if (Config.getInstance().getPluginStatus('client_login')) {
                this.buy();
            } else {
                this.showClientInfo();
            }
        },

        /**
         * Creates product order and redirect to payment or to sign up client.
         */
        buy: function () {
            if (this._cartModel.isEmpty()) {
                this._redirectWithReplace('products');
            }

            this._cartModel.createInvoice({
                success: _.bind(function (model) {
                    if (model.get('invoice')) {
                        // console.log('clear cart on checkout success');
                        var invoiceId = model.get('invoice').get('id');
                        this._cartModel.clear();

                        this._redirectWithReplace('invoice/pay/' + invoiceId);
                    } else {
                        console.error('No invoice in response - this situation should not happen!');
                        // if there is no invoice, then it is a free product?
                        // this._redirectWithReplace('membership/my/status/' + model.get('status'));
                    }
                }, this),
                error: _.bind(function (model, xhr) {
                    var result = xhr.responseJSON;
                    if (result && result.login_client) {
                        this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('products/buy'));
                    } else {
                        this.showErrorMessage(result.error);
                    }
                }, this)
            });
        },

        showClientInfo: function () {
            this.getMainLayout().getContentRegion().show(
                this.getClientController().createView()
            );
        },

        getClientController: function () {
            if (!this._clientConstroller) {
                this._clientConstroller = new ClientSubController({
                    clientModel: this.getOption('clientModel'),
                    app: this.getOption('app'),
                    formTitle: 'product_client_info_form_title',
                    formSubTitle: 'product_client_info_form_sub_title',
                    backButtonLabel: 'back',
                    backButtonLink: '#product',
                    submitButtonLabel: 'continue'
                });
                this.listenTo(this._clientConstroller, 'client:saved', _.bind(function () {
                    this.buy();
                }, this));
            }
            return this._clientConstroller;
        },


        /**
         * Shows error message
         *
         * @param String error
         */
        showErrorMessage: function (error) {
            if (this._view && !this._view.isDestroyed) {
                this._view.showErrorMessage(error);
            } else {
                this._message = error;

                this._redirect('product');
            }
        },

        checkCategories: function () {
            // if (this._categoryCollection.length == 1) {
            //     this._redirectWithReplace('products/category/' + this._categoryCollection.first().id);
            // }
        }

    });

});
